export const SET_DATEV_ACCOUNTING_DATA = 'SET_DATEV_ACCOUNTING_DATA'

export const SET_DATEV_PLATFORM_RESTAURANTS_DATA = 'SET_DATEV_PLATFORM_RESTAURANTS_DATA'

export const SET_DATEV_ADDITIONAL_PAYMENT_CONFIGS = 'SET_DATEV_ADDITIONAL_PAYMENT_CONFIGS'

export const SET_DATEV_ACTIVATION = 'SET_DATEV_ACTIVATION'

export const SET_DATEV_LOADING = 'SET_DATEV_LOADING'
